import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore'
import { FaAnglesLeft } from 'react-icons/fa6'
import { db } from '../../../firebase'
import { HiOutlineGlobeAlt } from 'react-icons/hi'
import { SiInstagram } from 'react-icons/si'

const JobsApp = () => {

    const [teamMembers, setTeamMembers] = useState([]);

    //read data from firebase
    useEffect(() => {
        const readTeamMembersData = async () => {
            const jobsRef = query(collection(db, 'team'), where('isVisible', '==', true))
            onSnapshot(jobsRef, (snapshot) => {
                setTeamMembers(snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })))

                console.log(teamMembers)
            })
        };
        readTeamMembersData();
    }, []);

    const navigate = useNavigate();

    return (
        <div className="flex justify-between">

            <section className="flex flex-col gap-[30px] xl:px-[60px] w-full">
                <p className="font-agrandir xl:text-[24px] text-[16px] text-white font-bold">The Team</p>


                <section className="flex pb-[30px]" id='blog'>

                    <div className="flex justify-start items-center">
                        <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-tangerine text-[14px]">
                            <FaAnglesLeft className='text-[10px]' />
                            Back
                        </Link>
                    </div>

                </section>

                <div className="grid lg:grid-cols-3 gap-5 grid-cols-1 lg:mt-0">
                    {teamMembers.map((teamMember, idx) => (

                        teamMember.data.type == "member" ? (
                            <div key={idx} className="flex relative lg:h-[500px] h-[450px] bg-darkgrey border border-black bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url(${teamMember.data.profilPicture})` }}>

                                <div className="flex items-center justify-between bg-tangerine w-full h-[70px] px-[1rem] absolute bottom-0 left-0">
                                    <div className="flex flex-col">
                                        <p className='text-[18px] font-bold uppercase'>{teamMember.data.name}</p>
                                        <p className='text-[13px]'>➔ {teamMember.data.actualPosition}</p>
                                    </div>

                                    <div className="flex gap-2.5 items-center justify-center">
                                        {teamMember.data.websiteLink !== "" && (
                                            <a className="text-black font-light lg:text-[20px] text-[34px]"
                                                href={teamMember.data.websiteLink} target="_blank" rel="noopener noreferrer">
                                                <HiOutlineGlobeAlt />
                                            </a>
                                        )}
                                        {teamMember.data.igHandle && (
                                            <a className="text-black font-light lg:text-[20px] text-[34px]"
                                                href={"https://www.instagram.com/" + teamMember.data.igHandle} target="_blank" rel="noopener noreferrer">
                                                <SiInstagram />
                                            </a>
                                        )}
                                    </div>
                                </div>

                            </div>
                        ) : (
                            /* Jobs Offer */
                            <div key={idx} className="flex flex-col justify-center relative lg:h-[500px] h-[450px]  px-[1.25rem] bg-shadowgreen border border-black bg-cover bg-no-repeat bg-center">

                                <div className="flex flex-col gap-4">
                                    <Link to={teamMember.data.directLink} className='flex justify-center items-center bg-black text-white font-bold px-[15px] py-2 w-fit'>APPLY NOW</Link>

                                    <div className='text-white uppercase'>
                                        <p className='font-bold text-[20px]'>{teamMember.data.jobtitle}</p>
                                        <p className=" text-[18px]">{teamMember.data.location}</p>
                                    </div>
                                </div>

                                <div className="flex items-start text-white w-full h-[70px] px-[1rem] absolute bottom-0 left-0">
                                    <p className='text-[20px] font-bold uppercase'>OPEN <br /> POSITION</p>
                                </div>

                            </div>
                        )
                    ))}


                </div>


                <div className="flex gap-5 fixed bottom-10 right-[30px] ">
                    <Link to={"/dashboard/team/new-member"} className='buttonblack border-white border'>Nouveau Membre</Link>
                    <Link to={"/dashboard/team/archives"} className='buttonblack border-white border'>Archives</Link>
                </div>

            </section>
        </div>
    )
}

export default JobsApp